import Typography from "@portal/components/atoms/v2/typography";
import { FC, useMemo } from "react";
import { formatNumberTwoDigits } from "@portal/utils/numberFormatters";
import { IExposedSector, ISectorExposureProps } from "./types";
import { SECTOR_EXPOSURE } from "./helper";
import { trackMessage } from "@portal/appInsights";
import { TextResources } from "@portal/assets/text/TextResources";
import Icon from "@portal/components/atoms/icons";

const SectorExposure: FC<ISectorExposureProps> = ({ morningstarSecurities }) => {
  const exposedSectors = useMemo(() => {
    return morningstarSecurities?.portfolios?.[0].globalStockSectorBreakdown
      ?.find(cp => cp.salePosition === "N")
      ?.breakdownValues.filter(r => r.value > 0)
      .sort((a, b) => b.value - a.value)
      .map(r => {
        const sector = SECTOR_EXPOSURE.find(sector => sector.type === r.type);
        if (!sector) {
          trackMessage(`Morningstar sector missing mapping ${JSON.stringify(r)}`);
          return null;
        }
        return { ...sector, value: r.value } as IExposedSector;
      })
      .filter(s => s !== null) as IExposedSector[];
  }, [morningstarSecurities]);
  const highestSectorValue = exposedSectors?.length > 0 && exposedSectors?.[0].value;

  if (!exposedSectors || exposedSectors.length === 0) {
    return (
      <div className="flex justify-center">
        <Typography>{TextResources.FUND_DISTRIBUTION_NO_SECTOR_DATA}</Typography>
      </div>
    );
  }

  return (
    <ul className="px-2 mt-4 flex flex-col gap-3">
      {exposedSectors?.map(sector => {
        const width = highestSectorValue ? Math.round((sector.value / (highestSectorValue ?? 1)) * 100) : 0;
        return (
          <li key={sector.name} className="flex justify-between items-center gap-2">
            <div className="w-full">
              <div className="flex items-center space-x-2">
                <Icon name={sector.icon} size="small" />
                <Typography>{sector.name}</Typography>
              </div>
              <div className="bg-blueLight rounded-full h-0.5" style={{ width: `${width}%` }}></div>
            </div>
            <div className="justify-self-end">
              <Typography>{formatNumberTwoDigits(sector.value)}%</Typography>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default SectorExposure;
